// hooks/useHrmsCounts.js
import { useEffect, useState } from "react";

let cache = null;

export const useHrmsCounts = (enabled = true) => {
  const [counts, setCounts] = useState(cache);
  const [loading, setLoading] = useState(!cache);

  // useEffect(() => {
  //   if (navigator.userAgent === "ReactSnap") return;
  // if (cache) return;

  const fetchCounts = async () => {
    const response = await fetch(
      `${import.meta.env.VITE_APIBASE_URL}/payslips/get-hrms-counts`,
    );

    const data = await response.json();

    if (data?.success) {
      cache = data.data;
      setCounts(data.data);
    }

    setLoading(false);
  };

  //   fetchCounts();
  // }, []);
  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") return;
    if (cache) return;
    if (!enabled) return;
    fetchCounts();
  }, [enabled]);

  return { counts, loading };
};
